/* eslint-disable no-extend-native */
/* eslint-disable import/no-anonymous-default-export */
import { Select } from "antd";
import { useState} from "react";
// import { Line } from '@ant-design/plots';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LineChart,
  Line,
  Legend,
  BarChart,
  Bar,
} from "recharts";
import styled from "styled-components";
import _ from "lodash";
import { NameType, Payload, ValueType } from "recharts/types/component/DefaultTooltipContent";

const TextTitle = styled.h2`
  margin-top: 0.3rem;
  font-size: 1.1rem;
  font-weight: 550;
  color: var(--primary-color);
  text-align: "center";
  padding-bottom: 1.5rem;
`;

const Container = styled.div`
position:relative;
`;
const ChartContainer = styled.div`
position:relative;
width: 100%;
background: white;
padding-top: 2rem;
padding-right:3rem;
padding-bottom: 2rem;
overflow: auto;
`
const Total = styled.div`
display: flex;
.hidden
{
  color:#9e9e9e!important;
  text-decoration:line-through;
}
& > div
{
  position: sticky;
  left: 0;
  padding-left: 1rem;
  display:flex;
  gap: 1rem;
  span 
  {
    cursor:pointer;
  }
}
margin-left: 2rem;
margin-top: 2rem;
justify-content: space-between;
align-items: center;
`;
const ChartWrapper = styled.div``;
let style = getComputedStyle(document.body);

//let primaryColor = style.getPropertyValue('--primary-color');


export type EstadisticasViewerData = { yName: string, dataArr: { key: string | number, value: number }[] };

export interface EstadisticasViewerProps {
  title?: string;
  data: EstadisticasViewerData[]
  xAxis: (string | number)[],
  yAxis: { name: string | number, color: string }[]
  width?: number
  height?: number,
  tooltipLabelFormatter?:(label:any, payload: Payload<ValueType, NameType>[])=>string
}

export default (props: EstadisticasViewerProps) => {
  const [hiddenY, setHiddenY] = useState<string[]>([]);
  const [chartType, setChartType] = useState<('LINE' | 'BAR')>('LINE');

  const toggleY = (yName: string) => {
    setHiddenY(_.includes(hiddenY, yName) ? hiddenY.filter(v => v != yName) : [...hiddenY, ...[yName]]);
  }

  const getFormattedData = () => {
    const arr: any = [];

    for (const xName of props.xAxis) {
      const data: any = {
        name: xName,
      };
      for (const i in props.yAxis) {
        const yName = props.yAxis[i].name;
        data[yName] = props.data.filter(v => v.yName == yName).at(0)?.dataArr.filter(v => v.key == xName).at(0)?.value ?? 0;
      }
      arr.push(data);
    }
    //|| _.includes(hiddenY, key)

    return arr;
  }

  const getTotals = () => {
    const totals: { key: string, value: number }[] = [];
    const data = getFormattedData();
    for (const key in data.at(0)) {
      if (key == 'name') continue;
      totals.push({ key, value: _.chain(data).sumBy(key).value() });
    }
    return totals;
  }

  // const config = {
  //   data,
  //   xField: props.dataKeyX,
  //   yField: "value",
  //   smooth: true,
  //   xAxis: {
  //     tickCount: props.hiddeAllDays ? 7 : 12,
  //   },
  //   color: primaryColor,
  //   lineStyle: {
  //     lineWidth: 2,
  //   },
  // };


  return (
    <Container>
      {props.title && <TextTitle>{props.title}</TextTitle>}

      <ChartContainer>
        {chartType == 'LINE' && <LineChart
          width={props.width ?? 900}
          height={props.height ?? 220}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          data={getFormattedData()}>
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            ticks={props.xAxis}
            dataKey={"name"}
          />
          <YAxis allowDecimals={false} />

          <Tooltip labelFormatter={props.tooltipLabelFormatter} />
          <Legend />
          {props.data.map((v, k) => <Line hide={_.includes(hiddenY, props.yAxis[k]?.name)} key={k} type="monotone" dataKey={props.yAxis[k]?.name} stroke={props.yAxis[k]?.color} />)}

        </LineChart>}

        {chartType == 'BAR' && <BarChart
          width={props.width ?? 900}
          height={props.height ?? 220}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          data={getFormattedData()}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            ticks={props.xAxis}
            dataKey={"name"}
          />
          <YAxis allowDecimals={false} />

          <Tooltip labelFormatter={props.tooltipLabelFormatter}  />
          <Legend />
          {props.data.map((v, k) => <Bar hide={_.includes(hiddenY, props.yAxis[k]?.name)} key={k} type="monotone" dataKey={props.yAxis[k]?.name} fill={props.yAxis[k]?.color} />)}
        </BarChart>}

        {getTotals().length > 0 && <Total>
          <div>{getTotals().map((v, k) =>
            <span className={_.includes(hiddenY, v.key) ? 'hidden' : ''}
              onClick={() => toggleY(v.key)}
              key={k}
              style={{ color: props.yAxis.filter(y => y.name == v.key).at(0)?.color }}><strong>{v.key}:</strong> {v.value}</span>)}
            <strong>Click en el dato para ocultar/mostrar</strong>
          </div>
          <Select value={chartType} onChange={(v) => setChartType(v)}>
            <Select.Option value="LINE">Gráfico de líneas</Select.Option>
            <Select.Option value="BAR">Gráfico de barras</Select.Option>
          </Select>
        </Total>}
      </ChartContainer>
    </Container>
  );
};




